import React, { Component } from 'react';

import Header from './Header';
import Content from './Content';
import Footer from './Footer';

// eslint-disable-next-line react/prefer-stateless-function
class LayoutLandingPage extends Component {
  render() {
    return (
      <div className="page page-bordered">
        <Header />
        <div className="page page-panel bg-main" style={{ padding: '32px 0' }}>
          <Content />
        </div>
        <Footer />
      </div>
    );
  }
}

export default LayoutLandingPage;



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutLandingPage/LayoutLandingPage.js